"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.default = void 0;

var _setAlign = _interopRequireDefault(require("./setAlign"));

/**
 * Set align content attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */
var setAlignContent = (0, _setAlign.default)('content');
var _default = setAlignContent;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/layout/lib/node/setAlignContent.js
// module id = 402
// module chunks = 0